import React from "react";
import { UncontrolledTooltip } from "reactstrap";

const InfoMessageTooltip = ({target, infoMessage}) => {
    return (
        <UncontrolledTooltip placement="top" trigger="hover" target={target}>{infoMessage}</UncontrolledTooltip>
    );
}

export default InfoMessageTooltip;